export const SET_VISITS = "account/SET_VISITS"
export const SET_NAME = "account/SET_NAME"
export const SET_CURRENT_VISIT = "account/SET_CURRENT_VISIT"
export const SET_PROFILES = "account/SET_PROFILES"
export const SET_HAS_SELF = "account/SET_HAS_SELF"
export const SET_PROFILE_DIRTY = "account/SET_PROFILE_DIRTY"
export const SET_PROFILE_ERROR = "account/SET_PROFILE_ERROR"
export const SET_VISIT_ERROR = "account/SET_VISIT_ERROR"
export const DELETE_ACCOUNT = "account/DELETE_ACCOUNT"
export const SET_FEATURES = "account/SET_FEATURES"
export const SET_PREDISPOSITIONS = "account/SET_PREDISPOSITIONS"
export const SET_PREDISPOSITION_ANSWER = "account/SET_PREDISPOSITION_ANSWER"
export const EDIT_PREDISPOSITIONS = "account/EDIT_PREDISPOSITIONS"
export const CANCEL_EDIT_PREDISPOSITIONS = "account/CANCEL_EDIT_PREDISPOSITIONS"



// WEBPACK FOOTER //
// ./assets/account/actionTypes.js